import classNames from 'classnames';
import { FC } from 'react';

import { InfoCircleSmall } from '@zooplus/icons';

import styles from './FormMessages.module.scss';

interface Props {
  infoMessageIcon?: React.ReactNode;
  infoMessage?: React.ReactNode;
  errorMessage?: React.ReactNode;
  errorZta?: string;
}

const FormMessages: FC<Props> = ({ infoMessage, errorMessage, infoMessageIcon, errorZta }) => {
  return (
    <>
      {infoMessage && (
        <div>
          <i className={classNames('v3-form__messageIcon', styles.infoIcon)}>
            {infoMessageIcon || <InfoCircleSmall />}
          </i>
          <span className="v3-form__message">{infoMessage}</span>
        </div>
      )}
      {errorMessage && (
        <div>
          <i
            className={classNames(
              'v3-form__messageIcon',
              'v3-form__messageIcon--error',
              styles.errorIcon,
            )}>
            <InfoCircleSmall />
          </i>
          <span className="v3-form__message" data-zta={errorZta}>
            {errorMessage}
          </span>
        </div>
      )}
    </>
  );
};

export default FormMessages;
